import { MathUtils } from '@shared/utils/MathUtils';
import { QuickTableComparingType } from '@shared/utils/QuickTableMisc/QuickTableComparingType';
export class BaseItem {
    constructor(sessionSettings) {
        this._isDisaplyed = false;
        this.Visible = true;
        this.IsGroupItem = false;
        this.QuickTableRow = null;
        this.QuickTableEditingInfoMap = {};
        /// <summary>
        /// +++ Цвета ячеек итема
        /// </summary>
        this.CellsColor = {}; // new Dictionary<int, Color>();
        /// <summary>
        /// +++ Цвета ячеек итема
        /// </summary>
        this.CellsForeColor = {};
        this.Disabled = false; // цвет текста ячеек disabled item-ов серый + др.особенности. Пример: PositionItem с OptionExerciseStatus = Pending exercise #93127
        this.superItemId = null; // ItemId of super item (for FIFO) #80010
        this.isSubItem = false; // ItemId != superItemId(for FIFO) #80010
        this.isNeedFireUpdate = false;
        this.NoIgnoreForceUpdateMapIndex = {}; // index = true
        this.sessionSettings = sessionSettings !== null && sessionSettings !== void 0 ? sessionSettings : null;
        this.itemId = BaseItem.AutoGeneratedId++;
    }
    get ItemId() {
        return this.itemId;
    }
    set ItemId(id) {
        this.itemId = id;
    }
    get isDisplayed() {
        return this._isDisaplyed;
    }
    set isDisplayed(value) {
        this._isDisaplyed = value;
    }
    ColumnCount() {
        return BaseItem.columnsParams.length;
    }
    isAllowEdit(columnIndex) {
        return false;
    }
    getColumnData(column) {
        return new ColumnData();
    }
    GetQuickTableEditingInfo(column) {
        return this.QuickTableEditingInfoMap[column] || null;
    }
    getQuickTableCellForeground(column) {
        return null;
    }
    fireUpdate() { }
    GetTooltipKey(column) {
        return '';
    }
    GetCurrentAccount() {
        return null;
    }
    GetCurrentInstrument() {
        return null;
    }
    getInstrumentDescription() {
        return null;
    }
    InstrumentName() {
        return null;
    }
    Dispose() {
        this.sessionSettings = null;
    }
    GetDataType(columnIndex) {
        return QuickTableComparingType.String;
    }
    getValueForTotalCalculation(column, totalCurrencyAfterFiltration) {
        var _a;
        const useAccCurrency = totalCurrencyAfterFiltration === null ||
            totalCurrencyAfterFiltration === ((_a = this.GetCurrentAccount()) === null || _a === void 0 ? void 0 : _a.assetName);
        const result = this.getColumnValue(column, useAccCurrency);
        const precision = this.getTotalValuePrecision(column, totalCurrencyAfterFiltration);
        return MathUtils.TruncateDouble(result, precision);
    }
    currentSideIsBuy() {
        return true;
    } // side of item if valid
    updateTotalCurrencyWith(assetName) {
        // total currency for item and argument (~assetname) #110253
        const account = this.GetCurrentAccount();
        const itemCurrency = account === null || account === void 0 ? void 0 : account.BaseCurrency;
        return itemCurrency != null // total Currency After Filtration
            ? assetName == null || itemCurrency === assetName
                ? itemCurrency
                : account === null || account === void 0 ? void 0 : account.DataCache.baseCurrency
            : null;
    }
    getFormatTotalValue(column, value, totalCurrencyAfterFiltration = null) {
        const precision = this.getTotalValuePrecision(column, totalCurrencyAfterFiltration);
        const formattedValue = MathUtils.TruncateDouble(value, precision);
        return formattedValue.toString();
    }
    getTotalValuePrecision(column, totalCurrencyAfterFiltration) {
        return 2;
    }
    NeedSortMenu() {
        return false;
    }
}
/// <summary>
/// Здесь хранятся настройки колонок (один экземпляр на класс)
/// </summary>
BaseItem.columnsParams = [];
BaseItem.AutoGeneratedId = 0;
export class ColumnData {
    constructor(Value = null, FormattedValue = null, GroupByValue) {
        this.Value = Value;
        this.FormattedValue = FormattedValue;
        this.GroupByValue = GroupByValue;
    }
}
